var React = require('react');

function IcAwsIamMfaToken (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M20,0C8.972,0,0,8.972,0,20c0,11.029,8.972,20,20,20c11.029,0,20-8.972,20-20S31.028,0,20,0z M20,38.067\n\tc-9.962,0-18.066-8.105-18.066-18.067S10.038,1.933,20,1.933S38.067,10.038,38.067,20S29.962,38.067,20,38.067z M11.46,20.488\n\tl-2.558-5.333h-2.22v9.379h1.786v-6.496l2.071,4.209h1.813l2.071-4.209v6.496h1.786v-9.379H14.03L11.46,20.488z M18.552,24.534\n\th2.031V20.65h3.085v-1.57h-3.085v-2.355h3.87v-1.57h-5.901C18.552,15.155,18.552,24.534,18.552,24.534z M30.015,15.155h-2.232\n\tl-3.302,9.379h2.124l0.636-2.138h3.208l0.663,2.138h2.205L30.015,15.155z M27.674,20.934l1.165-3.926l1.191,3.926H27.674z"}));
}

IcAwsIamMfaToken.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsIamMfaToken;

IcAwsIamMfaToken.default = IcAwsIamMfaToken;
